import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectComponent } from '@ng-select/ng-select';
import { Store } from '@ngrx/store';
import { ToastrService } from 'ngx-toastr';
import {
  Observable,
  Subject,
  Subscription,
  debounceTime,
  distinctUntilChanged,
  of,
  switchMap,
} from 'rxjs';
import Swal from 'sweetalert2';
import { ChargesWithdrawalsRequestService } from '../../../../../../../core/services/charges-withdrawals-request.service';
import { DynamicModalService } from '../../../../../../../core/services/dynamic-modal.service';
import { FinancialService } from '../../../../../../../core/services/financial.service';
import { HolderAccountBankService } from '../../../../../../../core/services/holder-account-bank.service';
import { PlayerService } from '../../../../../../../core/services/player.service';
import { UserService } from '../../../../../../../core/services/user.service';
import { selectAuth } from '../../../../../../../core/state/auth/auth.selector';
import {
  INTERBANK_TRANSDFER_OPTIONS,
  minimum_amount_ec,
  minimum_amount_pe,
  TRANSACTION_TYPES,
  ALLOWED_TYPES_FOR_BANK,
  ALLOWED_TYPES_FOR_AGENT_READONLY,
  ALLOWED_TYPES_FOR_AGENT_READONLY_SPECIAL,
  ALLOWED_TYPES_FOR_AGENT_PLAYER,
  ALLOWED_TYPES_FOR_HOLDER,
  ALLOWED_TYPES_FOR_RECEIPT,
  ALLOWED_TYPES_FOR_IDENTIFICATION,
  ALLOWED_TYPES_FOR_BENEFICIARY,
  ALLOWED_TYPES_FOR_CHECK_RECEIPT,
  ALLOWED_TYPES_FOR_UPLOAD_WITHDRAWAL_DIRECT,
  TRANSACTION_TYPE_VALUES,
  ALLOWED_TYPES_FOR_STATUS_RISKY_RECEIPT,
  ALLOWED_TYPES_FOR_MONTO,
  ALLOWED_TYPES_FOR_MONTO_BANK_ID_ACCOUNT,
  ALLOWED_TYPES_FOR_MONTO_BANK_RECEIPT,
  INTERBANK_TRANSDFER_OPTIONS_VALUES,
  ACCOUNT_TYPES,
  PAGE_SIZE_VALUE,
  DEFAULT_VALUE,
  ACCOUNT_TYPES_TEXT,
  ALERTS_TYPES,
  TRUE_CHECK_VALUE,
  CURRENCY_VALUES,
  CW_PASTE_FIELD_KEYWORDS,
  CW_PASTE_FIELDS,
  CW_PASTE_RULES,
  CW_PASTE_TEXT,
  CW_PASTE_TOAST,
  type CwPasteField,
  WITHDRAWAL_DIRECT_LIMIT,
  WITHDRAWAL_DIRECT_LIMIT_KEY,
  WITHDRAWAL_TYPES_FOR_DIRECT_DEFAULT,
} from '../../../../../../../shared/data/suscriptions-payments/constants';
import { ImageCompressionService } from '../../../../../../../shared/services/image-compression.service';
import {
  ROLES,
  USER_TYPES,
} from '../../../../../../../shared/data/config/constants';
import { ActivatedRoute, Router } from '@angular/router';
import { UserMainService } from '../../../../../../user/services/user-main.service';
import {
  TYPE_TRANSACTIONS_PERMISSIONS,
  REQUEST_WITHDRAWAL_BUTTON_PERMISSIONS,
} from '../../../../../../../shared/data/config/constants-buttons';
import {
  DEFAULT_ATTEMPS,
  DETAIL_NORMALIZE,
  GENERIC_LABELS,
  NON_NAME_KEYWORDS,
  TYPE_BANK,
  userOnlyActive,
} from '../../../../../../../core/constants/constants';
import moment from 'moment-timezone';
import { OcrService } from '../../../../../../../core/services/api/ocr.service';
import { BankData, OcrResponse } from '../../../../../../../core/interfaces/ui/ocr.interface';
import { showOcrPartialWarning } from '../../../../../../../core/utils/ocr-warning.util';
import { BankMatcherService } from '../../../../../../../core/services/ui/bank-matcher.service';
import { ConfiguracionCenterAdminService } from '../../../../../../../core/services/configuracion-center-admin.service';
interface Alert {
  type: string;
  message: string;
}

interface FilePreview {
  file: File;
  previewVisible: boolean;
  urlFile: string;
}

@Component({
  selector: 'app-create-cw-request',
  templateUrl: './create-cw-request.component.html',
  styleUrl: './create-cw-request.component.scss',
})
export class CreateCwRequestComponent implements OnInit {
  @ViewChild(NgSelectComponent) ngSelect!: NgSelectComponent;
  @Input() defaultValue: any;
  @ViewChild('montoInput') montoInput!: ElementRef;
  @ViewChild('fileInput') fileInput!: ElementRef;

  public optionsTypeTransactions$!: Observable<
    { value: string; label: string }[]
  >;
  public optionsAgents$!: Observable<string[]>;
  public optionsPlayers$!: Observable<string[]>;
  public optionsHolder$!: Observable<{ label: string; value: any }[]>;
  public optionsInterbankTransfer$!: Observable<
    { value: string; label: string }[]
  >;
  public isAgent = true;
  public isHolder = true;
  public loading = false;
  public cwForm!: FormGroup;
  public loadedItemCount = 0;
  public currentPageAgents = 1;
  public countAgents = 0;
  public currentPagePlayers = 1;
  public countPlayers = 0;
  public currentPageHolders = 1;
  public countHolders = 0;
  public pageSize = 10;
  public allAgentsData: any[] = [];
  public allHoldersData: any[] = [];
  public allPlayersData: any[] = [];
  public allClientBankData: any[] = [];
  public allEnterpriseBankData: any[] = [];
  public criteria: any;
  public previewImage: string | undefined;
  public transformedDataBank: any;
  public loadingImg = false;
  public loadingProgress = 0;
  public alerts: Alert[] = [];
  public selectedFiles: FilePreview[] = [];
  public idCodigo: number = 0;
  public profile$ = this.store.select(selectAuth);
  public profile: any;
  public id!: number;
  public rol!: number;
  public receipVoucher: any;
  public amountVoucher: any;
  public amountError: boolean = false;
  public reciptError: boolean = false;
  public isManual = false;
  public valueManual!: boolean;
  public id_country!: any;
  public currentPageBanks = 1;
  public showAmountErrorMessage: boolean = false;
  public amountErrorMessage: string = '';
  public alloweEnterprise: boolean = false;
  public selectedBankId!: number;
  public selectedAccountNumber: any[] = [];
  public transfer_Type: any;
  public inappropiatedComment: any;
  public tipo_usuario: any;
  public isLoadingButton = false;
  private holderSubject: Subject<string> = new Subject<string>();
  public blackList: boolean = false;
  public entityType: string = '';
  public pasteTextArea: string = '';
  public idusuario: number = 0;
  public isFileRequired: boolean = false;
  public isPaymentBoss: boolean = false;
  public isMobile: boolean = false;
  public token!: string;
  public roles = ROLES;
  public userType = USER_TYPES;
  public TRANSACTION_TYPE_VALUES = TRANSACTION_TYPE_VALUES;
  public ALLOWED_TYPES_FOR_BANK = ALLOWED_TYPES_FOR_BANK;
  public ALLOWED_TYPES_FOR_AGENT_READONLY = ALLOWED_TYPES_FOR_AGENT_READONLY;
  public ALLOWED_TYPES_FOR_AGENT_READONLY_SPECIAL =
    ALLOWED_TYPES_FOR_AGENT_READONLY_SPECIAL;
  public ALLOWED_TYPES_FOR_AGENT_PLAYER = ALLOWED_TYPES_FOR_AGENT_PLAYER;
  public ALLOWED_TYPES_FOR_HOLDER = ALLOWED_TYPES_FOR_HOLDER;
  public ALLOWED_TYPES_FOR_RECEIPT = ALLOWED_TYPES_FOR_RECEIPT;
  public ALLOWED_TYPES_FOR_IDENTIFICATION = ALLOWED_TYPES_FOR_IDENTIFICATION;
  public ALLOWED_TYPES_FOR_BENEFICIARY = ALLOWED_TYPES_FOR_BENEFICIARY;
  public ALLOWED_TYPES_FOR_CHECK_RECEIPT = ALLOWED_TYPES_FOR_CHECK_RECEIPT;
  public ALLOWED_TYPES_FOR_UPLOAD_WITHDRAWAL_DIRECT =
    ALLOWED_TYPES_FOR_UPLOAD_WITHDRAWAL_DIRECT;
  public REQUEST_WITHDRAWAL_BUTTON_PERMISSIONS =
    REQUEST_WITHDRAWAL_BUTTON_PERMISSIONS;
  public ALLOWED_TYPES_FOR_STATUS_RISKY_RECEIPT =
    ALLOWED_TYPES_FOR_STATUS_RISKY_RECEIPT;
  public ALLOWED_TYPES_FOR_MONTO = ALLOWED_TYPES_FOR_MONTO;
  public ALLOWED_TYPES_FOR_MONTO_BANK_ID_ACCOUNT =
    ALLOWED_TYPES_FOR_MONTO_BANK_ID_ACCOUNT;
  public ALLOWED_TYPES_FOR_MONTO_BANK_RECEIPT =
    ALLOWED_TYPES_FOR_MONTO_BANK_RECEIPT;
  public excludeIdTitularConditions = [
    TRANSACTION_TYPE_VALUES.WITHDRAW_BALANCE.toString(),
    TRANSACTION_TYPE_VALUES.COLLECT_COMMISSION.toString(),
  ];
  private holdersSubscription?: Subscription;
  private lastResolvedHolderBankId: number | null = null;
  public isSaving: boolean = true;
  public accountTypeLabel: string = 'Ahorros';
  public isRiskyTicket: boolean = false;
  public identificationError: boolean = false;
  public numberAccountError: boolean = false;
  public isBackofficePlayer: boolean = false;
  public isBackofficeAgent: boolean = false;
  public isFillingFromPaste: boolean = false;
  private isOcrAutoFilling: boolean = false;
  private withdrawalDirectLimit: number = WITHDRAWAL_DIRECT_LIMIT;
  public activeOcrProvider: 'gemini' | 'ollama' = 'gemini';

  constructor(
    private store: Store,
    private fb: FormBuilder,
    private activeModal: NgbActiveModal,
    private _userMainService: UserMainService,
    private _userService: UserService,
    private _playerService: PlayerService,
    private ocrService: OcrService,
    private sanitizer: DomSanitizer,
    private _cwService: ChargesWithdrawalsRequestService,
    private dynamicModal: DynamicModalService,
    private _holderAccountBank: HolderAccountBankService,
    private _toastrSvc: ToastrService,
    private _imageCompressionService: ImageCompressionService,
    private activedRouter: ActivatedRoute,
    private router: Router,
    private _bankMatcher: BankMatcherService,
    private _configService: ConfiguracionCenterAdminService,
  ) {
    this.holderSubject.pipe(debounceTime(400)).subscribe((term: any) => {
      this.allAgentsData = [];
      this.allPlayersData = [];
      this.allHoldersData = [];
      this.allEnterpriseBankData = [];
      this.allClientBankData = [];
      this.selectedAccountNumber = [];
      if (this.isAgent) {
        this.loadAgents(term);
      } else {
        this.loadPlayers(term);
      }
      this.loadHolders(term, true);
      this.getBankData(term);
    });
  }

  async ngOnInit(): Promise<void> {
    await this.initForm();
    const fullUrl = this.router.url;
    this.isMobile = fullUrl.includes('/mobile');
    if (this.isMobile) {
      await this.loadTokenLogged();
    } else {
      await this.loadProfileLogged();
    }
    this.loadTypeTransfer();
    this.loadTypeTransactions();
    this.getBankData();
    this.loadAgents();
    this.loadPlayers();
    this.loadHolders();
    this.watchFormChanges();

    this.id_country = this.resolveCountryId();
    this.loadWithdrawalDirectLimit();
    this.loadActiveOcrProvider();

    const isManualFromStorage = localStorage.getItem('isManual');
    this.isManual = isManualFromStorage === 'true';
    this.validatorsAmountImg();
    this.validatorsReciptImg();
  }

  ngOnDestroy(): void {
    if (this.holdersSubscription) {
      this.holdersSubscription.unsubscribe();
    }
  }

  async loadProfileLogged() {
    await new Promise<void>((resolve, reject) => {
      this.profile$.subscribe({
        next: (res) => {
          if (res.idusuario !== -1) {
            this.profile = res;
            this.tipo_usuario = this.profile.tipo_usuario.toString();
            this.rol = this.profile.id_rol;

            if (this.tipo_usuario === USER_TYPES.AGENT_LEVEL_ONE) {
              this.cwForm.get('id_agente')?.setValue(this.profile.idusuario);
            }
            resolve();
          }
        },
        error: (err) => {
          reject(err);
        },
      });
    });
  }
  async loadTokenLogged() {
    await new Promise<void>((resolve, reject) => {
      const fullUrl = this.router.url;
      const lastSlashIndex = fullUrl.lastIndexOf('/');
      const queryParamIndex = fullUrl.indexOf('?');
      if (queryParamIndex !== -1 && queryParamIndex > lastSlashIndex) {
        this.token = fullUrl.substring(lastSlashIndex + 1, queryParamIndex);
      } else {
        this.token = fullUrl.substring(lastSlashIndex + 1);
      }
      this._userService.getUserByTokenApp(this.token).subscribe({
        next: (res) => {
          if (res.data.idusuario) {
            this.profile = res.data;
            this.tipo_usuario = this.profile.tipo_usuario.toString();
            this.rol = this.profile.id_rol;

            this.updateTransactionValidators(
              this.cwForm.get('tipo_transaccion')?.value,
              this.tipo_usuario,
            );
            if (this.tipo_usuario === USER_TYPES.AGENT_LEVEL_ONE) {
              this.cwForm.get('id_agente')?.setValue(this.profile.idusuario);
            }
            resolve();
          } else {
            reject(new Error('No user id found'));
          }
        },
        error: (err) => {
          reject(err);
        },
      });
    });
  }

  getBankData(searchTerm?: string) {
    this.id_country = this.resolveCountryId();
    if (!this.id_country) {
      this.transformedDataBank = [];
      this.allEnterpriseBankData = [];
      this.allClientBankData = [];
      return;
    }

    this._userMainService
      .getAllBanksBySelect(
        this.currentPageBanks,
        this.pageSize,
        searchTerm,
        this.id_country,
      )
      .subscribe((response) => {
        this.transformedDataBank = response.data.map((item) => {
          return { label: item.bankName, value: item.bankId };
        });
        this.allEnterpriseBankData = [
          ...this.allEnterpriseBankData,
          ...this.transformedDataBank,
        ];
        this.allClientBankData = [
          ...this.allClientBankData,
          ...this.transformedDataBank,
        ];
      });
  }

  private normalizeCountryId(value: any): number | null {
    if (
      value === undefined ||
      value === null ||
      value === '' ||
      value === 'null' ||
      value === 'undefined'
    ) {
      return null;
    }

    const normalizedValue = Number(value);
    return Number.isInteger(normalizedValue) && normalizedValue > 0
      ? normalizedValue
      : null;
  }

  private resolveCountryId(): number | null {
    return (
      this.normalizeCountryId(this.dynamicModal.getModalData()) ??
      this.normalizeCountryId(this.id_country) ??
      this.normalizeCountryId(this.profile?.id_pais)
    );
  }

  onBankSelected(_event?: { value: any }) {
    this.refreshHoldersForSelectedBank();
  }

  hasPermission(permissionId: number): boolean {
    return this.profile?.rol?.permisos_principales.some(
      (permisoPrincipal: any) =>
        permisoPrincipal.permisos.some(
          (permiso: any) => permiso.id === permissionId,
        ),
    );
  }

  loadTypeTransactions() {
    this.isRiskyTicket = this.cwForm.get('estado_boleta_riesgosa')?.value;

    let filteredTransactionTypes;

    if (this.isRiskyTicket) {
      filteredTransactionTypes = TRANSACTION_TYPES.filter(
        (item) =>
          item.value === TRANSACTION_TYPE_VALUES.LOAD_RISK_VOUCHER.toString() ||
          item.value ===
            TRANSACTION_TYPE_VALUES.WITHDRAW_RISK_VOUCHER.toString(),
      );
    } else {
      let baseFilteredTransactionTypes = TRANSACTION_TYPES.filter(
        (item) => item.value !== TRANSACTION_TYPE_VALUES.FINANCIAL.toString(),
      );

      if (this.isAgent) {
        filteredTransactionTypes = baseFilteredTransactionTypes.filter(
          (item) =>
            item.value !==
              TRANSACTION_TYPE_VALUES.LOAD_RISK_VOUCHER.toString() &&
            item.value !==
              TRANSACTION_TYPE_VALUES.WITHDRAW_RISK_VOUCHER.toString(),
        );
      } else {
        filteredTransactionTypes = baseFilteredTransactionTypes.filter(
          (item) =>
            item.value === TRANSACTION_TYPE_VALUES.LOAD_BALANCE.toString() ||
            item.value ===
              TRANSACTION_TYPE_VALUES.WITHDRAW_BALANCE.toString() ||
            item.value === TRANSACTION_TYPE_VALUES.PAY_TO_DEBIT.toString() ||
            item.value === TRANSACTION_TYPE_VALUES.CREDIT_DEPOSIT.toString() ||
            item.value === TRANSACTION_TYPE_VALUES.CREDIT_WITHDRAWAL.toString(),
        );
      }
    }

    filteredTransactionTypes = filteredTransactionTypes.filter((item) => {
      if (
        item.value ===
          TRANSACTION_TYPE_VALUES.WITHDRAW_RISK_VOUCHER.toString() &&
        !this.hasPermission(
          TYPE_TRANSACTIONS_PERMISSIONS.RISKY_WITHDRAWAL_TICKET,
        )
      ) {
        return false;
      }
      if (
        item.value === TRANSACTION_TYPE_VALUES.CREDIT_DEPOSIT.toString() &&
        !this.hasPermission(TYPE_TRANSACTIONS_PERMISSIONS.DEPOSIT_CREDIT)
      ) {
        return false;
      }
      if (
        item.value === TRANSACTION_TYPE_VALUES.CREDIT_WITHDRAWAL.toString() &&
        !this.hasPermission(TYPE_TRANSACTIONS_PERMISSIONS.WITHDRAWAL_CREDIT)
      ) {
        return false;
      }
      if (
        item.value === TRANSACTION_TYPE_VALUES.LOAD_BONUS_BALANCE.toString() &&
        !this.hasPermission(TYPE_TRANSACTIONS_PERMISSIONS.BONUS_BALANCE_CHARGE)
      ) {
        return false;
      }
      return true;
    });

    this.optionsTypeTransactions$ = of(filteredTransactionTypes);

    if (!this.isRiskyTicket) {
      const currentTransactionType = this.cwForm.get('tipo_transaccion')?.value;
      const isCurrentTypeValid = filteredTransactionTypes.some(
        (item) => item.value === currentTransactionType,
      );

      if (!isCurrentTypeValid || !currentTransactionType) {
        this.cwForm
          .get('tipo_transaccion')
          ?.setValue(TRANSACTION_TYPE_VALUES.LOAD_BALANCE.toString());
      }
    }
  }

  onTransactionTypeChange() {
    const transactionType = this.cwForm.get('tipo_transaccion')?.value;
    if (
      transactionType !== TRANSACTION_TYPE_VALUES.CREDIT_DEPOSIT.toString() &&
      transactionType !== TRANSACTION_TYPE_VALUES.CREDIT_WITHDRAWAL.toString()
    ) {
      this.loadTypeTransactions();
    }
  }

  loadTypeTransfer() {
    this.optionsInterbankTransfer$ = of(INTERBANK_TRANSDFER_OPTIONS);
    this.cwForm
      .get('transferencia_interbancaria')
      ?.setValue(INTERBANK_TRANSDFER_OPTIONS_VALUES.NO.toString());
  }

  loadAgents(searchTerm?: string) {
    this._userMainService
      .getAllReferredAndAgents(
        this.currentPageAgents,
        this.pageSize,
        searchTerm,
        this.id_country,
        userOnlyActive,
      )
      .pipe(
        distinctUntilChanged(),
        switchMap((response) => {
          const transformedData = response.data.map((item: any) => ({
            label: item.usuario,
            value: item.idusuario,
            backofficeAgent: item.id_remoto,
            whiteList: item.agente_white_list?.lista_negra,
          }));
          const uniqueData = transformedData.filter(
            (newItem: any) =>
              !this.allAgentsData.some(
                (existingItem) => existingItem.value === newItem.value,
              ),
          );
          this.allAgentsData = [...this.allAgentsData, ...uniqueData];
          return of(this.allAgentsData);
        }),
      )
      .subscribe((data) => {
        this.optionsAgents$ = of(data);
      });
  }

  loadPlayers(searchTerm?: string) {
    this._playerService
      .getPlayers(
        this.id_country,
        this.currentPagePlayers,
        this.pageSize,
        searchTerm,
      )
      .subscribe((response) => {
        const transformedData = response.data.map((item: any) => {
          return {
            label: item.usuario_jugador,
            value: item.id_jugador,
            whiteList: item.jugador_white_list?.lista_negra,
            backofficePlayer: item.id_remoto,
            id_usuario: item.id_usuario,
          };
        });

        this.optionsPlayers$ = of(transformedData);
        this.allPlayersData = [...this.allPlayersData, ...transformedData];
      });
  }

  loadHolders(searchTerm?: string, resetData: boolean = true) {
    if (this.holdersSubscription) {
      this.holdersSubscription.unsubscribe();
    }

    if (resetData) {
      this.allHoldersData = [];
      this.selectedAccountNumber = [];
      this.currentPageHolders = 1;
    }

    this.holdersSubscription = this._holderAccountBank
      .getAllHoldersAccountData(
        this.currentPageHolders,
        this.pageSize,
        this.id_country,
        this.selectedBankId,
        searchTerm,
      )
      .subscribe((res) => {
        const response = res.data;
        const transformedData = response.data.map(
          (item: {
            holder: any;
            id_usuario: any;
            bank: any;
            account_number: any;
            id_banco: any;
          }) => {
            this.selectedAccountNumber.push({
              value: item.account_number,
              id: item.id_usuario,
              bankId: item.id_banco,
            });

            return {
              label:
                item.holder +
                ' (' +
                item.bank +
                ' - ' +
                item.account_number +
                ')',
              value: item.id_usuario,
            };
          },
        );

        const uniqueData = transformedData.filter(
          (newItem: any) =>
            !this.allHoldersData.some(
              (existingItem) => existingItem.value === newItem.value,
            ),
        );

        this.optionsHolder$ = of([...this.allHoldersData, ...uniqueData]);
        this.allHoldersData = [...this.allHoldersData, ...uniqueData];
      });
  }

  onScrollToEnd() {
    if (this.isAgent) {
      this.currentPageAgents++;
      if (this.isAgent) {
        this.loadAgents(this.criteria);
      } else {
        this.loadAgents();
      }
    } else {
      this.currentPagePlayers++;
      if (!this.isAgent) {
        this.loadPlayers(this.criteria);
      } else {
        this.loadPlayers();
      }
    }

    this.currentPageHolders++;
    this.currentPageBanks++;

    this.getBankData(this.criteria);
    this.loadHolders(this.criteria, false);
  }

  onSearch(term: string) {
    this.criteria = term.trim();
    this.allAgentsData = [];
    this.allPlayersData = [];
    this.allClientBankData = [];
    this.allEnterpriseBankData = [];
    this.currentPageAgents = PAGE_SIZE_VALUE;
    this.currentPagePlayers = PAGE_SIZE_VALUE;
    this.currentPageHolders = PAGE_SIZE_VALUE;
    this.currentPageBanks = PAGE_SIZE_VALUE;
    this.holderSubject.next(term);
  }
  onSearchBank() {
    this.selectedBankId = DEFAULT_VALUE;
  }

  closeModal() {
    this.clearAttachedImageState();
    this.activeModal.close();
    this.cwForm.reset();
  }

  toggleSwitch() {
    const currentControlName = this.isAgent ? 'id_agente' : 'id_jugador';
    const oppositeControlName = this.isAgent ? 'id_jugador' : 'id_agente';

    this.cwForm.get(currentControlName)?.setValue(null);

    this.cwForm.get(oppositeControlName)?.setValue(null);

    this.isAgent = !this.isAgent;
    this.loadTypeTransactions();
  }

  manualSwitch() {
    this.isManual = !this.isManual;
    this.amountError = false;
    this.reciptError = false;
    this.validatorsAmountImg();
    this.validatorsReciptImg();
    localStorage.setItem('isManual', String(this.isManual));
  }

  toggleAccountType(event: any): void {
    this.isSaving = !this.isSaving;
    this.accountTypeLabel = this.isSaving
      ? ACCOUNT_TYPES_TEXT.SAVINGS
      : ACCOUNT_TYPES_TEXT.CURRENT;
  }

  clearDangerAlerts(): void {
    this.alerts = this.alerts.filter(
      (alert) => alert.type !== ALERTS_TYPES.DANGER,
    );
  }

  showDangerAlert(message: string): void {
    this.alerts.push({ type: ALERTS_TYPES.DANGER, message: message });
  }

  closeAlert(alert: Alert): void {
    this.alerts.splice(this.alerts.indexOf(alert), TRUE_CHECK_VALUE);
  }

  watchFormChanges(): void {
    this.cwForm.get('comprobante')?.valueChanges.subscribe((val) => {
      if (val && this.cwForm.get('monto')?.value) {
        this.clearDangerAlerts();
      }
    });

    this.cwForm.get('tipo_transaccion')?.valueChanges.subscribe(() => {
      this.checkMinimumAmount();
    });

    this.cwForm.get('monto')?.valueChanges.subscribe((val) => {
      this.checkMinimumAmount();
      if (val && this.cwForm.get('comprobante')?.value) {
        this.clearDangerAlerts();
      }
      const transactionType = this.cwForm.get('tipo_transaccion')?.value;
      this.cwForm.get('cargar_retirar_directo')?.setValue(
        this.getDefaultDirectValue(transactionType, val),
        { emitEvent: false }
      );
    });
  }

  async onFileSelected(event: any) {
    const file: File = event.target.files[DEFAULT_VALUE];

    if (file) {
      if (!file.type.startsWith('image/')) {
        this._toastrSvc.error('Solo se permiten imágenes en formato JPG o PNG');
        return;
      }

      try {
        const compressedFile =
          await this._imageCompressionService.compressImage(file);
        const url = this.fileUrl(compressedFile);

        this.selectedFiles = [
          {
            file: compressedFile,
            previewVisible: true,
            urlFile: url,
          },
        ];
        this.previewImage = url;
        this.processFile(compressedFile);
        event.target.value = '';
      } catch (error) {
        this._toastrSvc.error('Error al comprimir la imagen');
      }
    }
  }

  triggerFileInput(event?: Event): void {
    if (event) {
      event.stopPropagation();
    }
    this.fileInput.nativeElement.click();
  }

  fileUrl(file: File): any {
    const url = URL.createObjectURL(file);
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  async uploadFiles(files: FileList) {
    if (files.length > DEFAULT_VALUE) {
      const file = files[DEFAULT_VALUE];

      if (!file.type.startsWith('image/')) {
        this._toastrSvc.error('Solo se permiten imágenes en formato JPG o PNG');
        return;
      }

      try {
        const compressedFile =
          await this._imageCompressionService.compressImage(file);
        const url = this.fileUrl(compressedFile);

        this.selectedFiles = [
          {
            file: compressedFile,
            previewVisible: true,
            urlFile: url,
          },
        ];
        this.previewImage = url;
      } catch (error) {
        this._toastrSvc.error('Error al comprimir la imagen');
      }
    }
  }

  onDrop($event: DragEvent) {
    $event.preventDefault();
    const files = $event.dataTransfer?.files;
    if (files && files.length > DEFAULT_VALUE) {
      this.uploadFiles(files);
      this.processFile(files[DEFAULT_VALUE]);
    }
  }

  onDragOver($event: DragEvent) {
    $event.preventDefault();
  }

  removeImage() {
    this.clearAttachedImageState();
    this.resetFormAfterRemovingImage();
  }

  private clearAttachedImageState(): void {
    this.previewImage = undefined;
    this.selectedFiles = [];
    this.amountVoucher = null;
    this.receipVoucher = null;
    this.amountError = false;
    this.reciptError = false;

    if (this.fileInput?.nativeElement) {
      this.fileInput.nativeElement.value = '';
    }
  }

  private resetFormAfterRemovingImage(): void {
    this.cwForm.reset({
      tipo_transaccion: null,
      monto: null,
      id_banco: null,
      id_banco_empresa: null,
      id_titular: null,
      comprobante: '',
      comprobante_empresa: '',
      nombre_titular: null,
      nombre_remitente: null,
      origen_comprobante_bot: null,
      id_agente: null,
      id_jugador: null,
      transferencia_interbancaria:
        INTERBANK_TRANSDFER_OPTIONS_VALUES.NO.toString(),
      detalle: null,
      identificacion: null,
      numero_cuenta: null,
      estado_revisar_boleta: false,
      permitirComprobante: false,
      cargar_retirar_directo: false,
      estado_boleta_riesgosa: false,
      estado_tiempo_espera: false,
    });

    this.cwForm.get('id_titular')?.disable();

    this.isRiskyTicket = false;
    this.loadTypeTransactions();
    this.cwForm
      .get('tipo_transaccion')
      ?.setValue(TRANSACTION_TYPE_VALUES.LOAD_BALANCE.toString());

    if (
      this.tipo_usuario === USER_TYPES.AGENT_LEVEL_ONE &&
      this.profile?.idusuario
    ) {
      this.cwForm.get('id_agente')?.setValue(this.profile.idusuario);
    }

    this.showAmountErrorMessage = false;
    this.amountErrorMessage = '';
    this.identificationError = false;
    this.numberAccountError = false;
    this.alloweEnterprise = false;
    this.selectedBankId = DEFAULT_VALUE;
    this.selectedAccountNumber = [];
  }

  processFile(file: File) {
    const reader = new FileReader();
    reader.onload = async (event) => {
      if (event.target) {
        const imageData = event.target.result as string;
        this.previewImage = imageData;

        const currentTransactionType = Number(
          this.cwForm.get('tipo_transaccion')?.value,
        );

        if (
          !this.isManual &&
          !this.shouldSkipOcrForTransaction(currentTransactionType)
        ) {
          this.isLoadingButton = true;
          this.cwForm.patchValue({
            comprobante: 'Procesando...',
            monto: 'Procesando...',
            detalle: 'Analizando...',
          });
          this.ocrService.extractData(file, DEFAULT_ATTEMPS).subscribe({
            next: (res: OcrResponse) => {
              showOcrPartialWarning(this._toastrSvc, res);

              if (res.data) {
                const data = res.data;
                const fechaInfo = data.fecha
                  ? `Fecha Transaccion: (${data.fecha})`
                  : `Fecha Transaccion: Sin fecha`;
                const sanitizedOcrDetail = this.getSanitizedOcrDetail(
                  data.detalle,
                  data.beneficiario,
                  !!data.detalle_riesgoso,
                );

                const normalizedAmount = this.normalizeAmountValue(data.monto);
                const patchData: Record<string, unknown> = {
                  monto: normalizedAmount,
                  comprobante:
                    data.id_comprobante?.toString().replace(/\s+/g, '') ?? null,
                  detalle: [fechaInfo, sanitizedOcrDetail]
                    .filter(Boolean)
                    .join('\n'),
                  nombre_remitente: data.nombre_remitente?.toString().trim() || null,
                  origen_comprobante_bot:
                    data.origen_comprobante_bot?.toString().trim() || null,
                };

                if (
                  currentTransactionType !==
                  TRANSACTION_TYPE_VALUES.WITHDRAW_BALANCE
                ) {
                  patchData.nombre_titular =
                    data.beneficiario?.toString().trim() || null;
                }

                this.cwForm.patchValue(patchData);

                this.amountVoucher = normalizedAmount;
                this.receipVoucher =
                  data.id_comprobante?.toString().replace(/\s+/g, '') ?? null;

                this.applyInterbankDataFromOcr(data, currentTransactionType);
                this.applyRiskyFlagFromOcr(data);
              }
              this.isLoadingButton = false;
              this.validatorsAmountImg();
              this.validatorsReciptImg();
            },
            error: (err) => {
              this.isLoadingButton = false;
              this._toastrSvc.error('No se pudo procesar la imagen con IA');
              this.cwForm.patchValue({
                comprobante: '',
                monto: '',
                detalle: '',
              });
            },
          });
        }
      }
    };
    reader.readAsDataURL(file);
  }

  shouldSkipOcrForTransaction(transactionType: number): boolean {
    return [
      TRANSACTION_TYPE_VALUES.CREDIT_DEPOSIT,
      TRANSACTION_TYPE_VALUES.CREDIT_WITHDRAWAL,
    ].includes(transactionType);
  }
  private applyRiskyFlagFromOcr(data: BankData): void {
    if (!data?.detalle_riesgoso) return;

    const currentTransactionType = Number(
      this.cwForm.get('tipo_transaccion')?.value,
    );
    const nextRiskyTransactionType = this.getRiskyTransactionTypeFromCurrent(
      currentTransactionType,
    );

    this.cwForm.patchValue(
      {
        estado_boleta_riesgosa: true,
        estado_revisar_boleta: false,
        cargar_retirar_directo: false,
      },
      { emitEvent: false },
    );
    this.loadTypeTransactions();
    this.cwForm
      .get('tipo_transaccion')
      ?.setValue(nextRiskyTransactionType.toString());
  }

  private getRiskyTransactionTypeFromCurrent(currentType: number): number {
    const withdrawLikeTypes = [
      TRANSACTION_TYPE_VALUES.WITHDRAW_BALANCE,
      TRANSACTION_TYPE_VALUES.COLLECT_COMMISSION,
      TRANSACTION_TYPE_VALUES.WITHDRAW_RISK_VOUCHER,
    ];

    if (withdrawLikeTypes.includes(currentType)) {
      return TRANSACTION_TYPE_VALUES.WITHDRAW_RISK_VOUCHER;
    }

    return TRANSACTION_TYPE_VALUES.LOAD_RISK_VOUCHER;
  }

  private normalizeRiskyText(value: string): string {
    return value
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');
  }

  private normalizeForComparison(value: string): string {
    return this.normalizeRiskyText(value)
      .replace(/[^a-z0-9\s]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  private looksLikePersonNameLine(normalizedLine: string): boolean {
    if (!normalizedLine) return false;

    const tokens = normalizedLine.split(' ').filter(Boolean);
    if (tokens.length < 2 || tokens.length > 6) return false;

    const isOnlyWords = tokens.every((token) => /^[a-z]+$/.test(token));
    if (!isOnlyWords) return false;

    const hasNonNameKeyword = tokens.some((token) =>
      NON_NAME_KEYWORDS.includes(token),
    );
    return !hasNonNameKeyword;
  }

  private getSanitizedOcrDetail(
    detalle: string | null | undefined,
    beneficiario?: string | null,
    hasRiskyContent: boolean = false,
  ): string | null {
    if (!detalle) return null;

    const rawDetail = String(detalle).trim();
    if (!rawDetail) return null;

    const detailLines = rawDetail
      .split('\n')
      .map((line) => line.trim())
      .filter(Boolean);
    const normalizedBeneficiary = beneficiario
      ? this.normalizeForComparison(String(beneficiario))
      : '';

    const filteredLines = detailLines.filter((line) => {
      const normalizedLine = this.normalizeForComparison(line);
      if (!normalizedLine) return false;

      if (GENERIC_LABELS.some((label) => normalizedLine.startsWith(label))) {
        return false;
      }

      if (
        normalizedBeneficiary &&
        (normalizedLine === normalizedBeneficiary ||
          normalizedLine.includes(normalizedBeneficiary))
      ) {
        return false;
      }

      if (this.looksLikePersonNameLine(normalizedLine)) {
        return false;
      }

      return true;
    });

    const sanitizedDetail = filteredLines.join('\n').trim();
    if (!sanitizedDetail) return null;

    const normalizedDetail = this.normalizeForComparison(sanitizedDetail);

    if (GENERIC_LABELS.some((label) => normalizedDetail.startsWith(label))) {
      return null;
    }

    if (
      normalizedBeneficiary &&
      (normalizedDetail === normalizedBeneficiary ||
        normalizedDetail.includes(normalizedBeneficiary))
    ) {
      return null;
    }

    const isDeunaDetail = normalizedDetail.includes(
      DETAIL_NORMALIZE.DEUNA_RECEIPT,
    );
    const isPeigoDetail = normalizedDetail.includes(DETAIL_NORMALIZE.PEIGO);

    if (!isDeunaDetail && !isPeigoDetail && !hasRiskyContent) {
      return null;
    }

    return sanitizedDetail;
  }

  private applyInterbankDataFromOcr(
    data: OcrResponse['data'],
    currentTransactionType: number,
  ): void {
    if (
      !this.isTransactionTypeAllowed(
        currentTransactionType,
        ALLOWED_TYPES_FOR_RECEIPT,
      )
    ) {
      return;
    }

    const interbankValue =
      typeof data?.interbank_transfer === 'number'
        ? data.interbank_transfer
        : data?.transferencia_interbancaria === true
          ? INTERBANK_TRANSDFER_OPTIONS_VALUES.YES
          : data?.transferencia_interbancaria === false
            ? INTERBANK_TRANSDFER_OPTIONS_VALUES.NO
            : null;

    const clientBankName =
      data?.banco_cliente_nombre ?? data?.banco_nombre ?? null;
    const enterpriseBankName = data?.banco_empresa_nombre ?? null;

    let matchedClientBankId: number | null = null;
    if (data?.id_banco) {
      matchedClientBankId = data.id_banco;
    } else if (clientBankName) {
      const bankOption = this._bankMatcher.findBestMatch(
        clientBankName,
        this.allClientBankData,
      );
      matchedClientBankId = bankOption?.value ?? null;
    }

    const matchedEnterpriseBankId = data?.id_banco_empresa ?? null;
    const hasSameSourceAndTargetBank =
      matchedClientBankId !== null &&
      matchedEnterpriseBankId !== null &&
      Number(matchedClientBankId) === Number(matchedEnterpriseBankId);

    const isInterbankOption = [
      INTERBANK_TRANSDFER_OPTIONS_VALUES.YES,
      INTERBANK_TRANSDFER_OPTIONS_VALUES.OTHERS,
    ]
      .map(String)
      .includes(String(interbankValue));

    const normalizedBanks = this.normalizeRiskyText(
      `${data?.banco_nombre ?? ''} ${data?.banco_cliente_nombre ?? ''} ${data?.banco_empresa_nombre ?? ''}`,
    );
    const detailNormalized = this.normalizeRiskyText(data?.detalle ?? '');
    const isDeunaPichinchaReceipt =
      detailNormalized.includes(DETAIL_NORMALIZE.DEUNA_RECEIPT) &&
      normalizedBanks.includes(DETAIL_NORMALIZE.PICHINCHA);

    const normalizedInterbankValue =
      isInterbankOption &&
      (hasSameSourceAndTargetBank || isDeunaPichinchaReceipt)
        ? INTERBANK_TRANSDFER_OPTIONS_VALUES.NO
        : interbankValue;

    this.isOcrAutoFilling = true;

    if (normalizedInterbankValue !== null) {
      this.cwForm
        .get('transferencia_interbancaria')
        ?.setValue(String(normalizedInterbankValue), { emitEvent: false });
    }

    if (matchedClientBankId) {
      this.ensureBankOptionExists(
        matchedClientBankId,
        clientBankName,
        'client',
      );
      this.cwForm.get('id_banco')?.setValue(matchedClientBankId, {
        emitEvent: false,
      });
    }

    if (
      [
        INTERBANK_TRANSDFER_OPTIONS_VALUES.YES,
        INTERBANK_TRANSDFER_OPTIONS_VALUES.OTHERS,
      ]
        .map(String)
        .includes(String(normalizedInterbankValue)) &&
      data?.id_banco_empresa
    ) {
      this.ensureBankOptionExists(
        data.id_banco_empresa,
        enterpriseBankName,
        'enterprise',
      );
      this.cwForm.get('id_banco_empresa')?.setValue(data.id_banco_empresa, {
        emitEvent: false,
      });
    } else if (matchedClientBankId) {
      this.cwForm.get('id_banco_empresa')?.setValue(matchedClientBankId, {
        emitEvent: false,
      });
    }

    this.transfer_Type = this.cwForm.get('transferencia_interbancaria')?.value;
    this.alloweEnterprise =
      this.transfer_Type ===
        INTERBANK_TRANSDFER_OPTIONS_VALUES.YES.toString() ||
      this.transfer_Type ===
        INTERBANK_TRANSDFER_OPTIONS_VALUES.OTHERS.toString();

    this.isOcrAutoFilling = false;
    this.refreshHoldersForSelectedBank();
  }

  processImage(imageData: string | ArrayBuffer | null) {
    if (imageData) {
      this.previewImage = imageData.toString();
    }
  }

  onSelectionChange() {
    const controlName = this.isAgent ? 'id_agente' : 'id_jugador';
    const oppositeControlName = this.isAgent ? 'id_jugador' : 'id_agente';
    const selectedValue = this.cwForm.get(controlName)?.value;

    this.cwForm.removeControl('id_personas');
    this.cwForm.addControl(
      controlName,
      this.fb.control(selectedValue, Validators.required),
    );
    this.cwForm.get(oppositeControlName)?.setValue(0);

    if (!selectedValue) {
      this.blackList = false;
      return;
    }

    const selectedItem = this.isAgent
      ? this.allAgentsData.find((agent) => agent.value === selectedValue)
      : this.allPlayersData.find((player) => player.value === selectedValue);

    if (!this.isAgent && selectedItem?.backofficePlayer) {
      this.isBackofficePlayer = true;
    } else {
      this.isBackofficePlayer = false;
    }

    if (this.isAgent && selectedItem?.backofficeAgent) {
      this.isBackofficeAgent = true;
    } else {
      this.isBackofficeAgent = false;
    }

    this.idusuario = selectedItem?.id_usuario;
    this.blackList = selectedItem?.whiteList === TRUE_CHECK_VALUE;
    this.entityType = this.isAgent ? 'agente' : 'jugador';
  }

  async initForm(): Promise<void> {
    this.createForm();
    await this.loadProfileBasedOnUrl();
    this.configureFormForPaymentsBoss();
    this.handleTransactionTypeChanges();
    this.handleTransferInterbankChanges();
    this.handleBankSelectionChanges();
    this.enableTitularFieldOnBankSelection();
    this.cwForm
      .get('monto')
      ?.valueChanges.subscribe((value) => this.checkProcessingState());
    this.cwForm
      .get('comprobante')
      ?.valueChanges.subscribe((value) => this.checkProcessingState());
    this.cwForm
      .get('detalle')
      ?.valueChanges.subscribe((value) => this.checkProcessingState());
  }

  createForm(): void {
    this.cwForm = this.fb.group({
      tipo_transaccion: [null, Validators.required],
      monto: [null, [Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
      id_banco: [null],
      id_banco_empresa: [null],
      id_titular: [{ value: null, disabled: true }],
      comprobante: [''],
      comprobante_empresa: [''],
      nombre_titular: [null],
      nombre_remitente: [null],
      origen_comprobante_bot: [null],
      id_agente: [null],
      id_jugador: [null],
      transferencia_interbancaria: [null],
      detalle: [null],
      identificacion: [null],
      numero_cuenta: [null],
      estado_revisar_boleta: false,
      permitirComprobante: false,
      cargar_retirar_directo: false,
      estado_boleta_riesgosa: false,
      estado_tiempo_espera: false,
    });
  }
  async loadProfileBasedOnUrl(): Promise<void> {
    const fullUrl = this.router.url;
    this.isMobile = fullUrl.includes('/mobile');
    if (this.isMobile) {
      await this.loadTokenLogged();
    } else {
      await this.loadProfileLogged();
    }
  }

  validateField(event: any, fieldName: string): void {
    const value = event.target.value;
    const regex = /^[a-zA-Z0-9-]*$/;

    if (fieldName === 'identificacion') {
      this.identificationError = !regex.test(value);
    }
    if (fieldName === 'numero_cuenta') {
      this.numberAccountError = !regex.test(value);
    }
  }

  configureFormForPaymentsBoss(): void {
    if (this.profile?.id_rol === ROLES.PAYMENTS_BOSS) {
      this.isPaymentBoss = true;
      this.cwForm.get('estado_boleta_riesgosa')?.setValue(true);
      this.cwForm
        .get('tipo_transaccion')
        ?.setValue(TRANSACTION_TYPE_VALUES.WITHDRAW_RISK_VOUCHER.toString());
      this.cwForm.get('tipo_transaccion')?.disable();
      this.cwForm.get('estado_boleta_riesgosa')?.disable();
    }
  }

  handleTransactionTypeChanges(): void {
    this.cwForm.get('tipo_transaccion')?.valueChanges.subscribe((value) => {
      this.updateTransactionValidators(value, this.tipo_usuario);
      this.updateFileRequirement(value);
    });

    this.cwForm.get('tipo_transaccion')?.valueChanges.subscribe(() => {
      this.cwForm
        .get('transferencia_interbancaria')
        ?.setValue(INTERBANK_TRANSDFER_OPTIONS_VALUES.NO);
      const transaction_type = this.cwForm.get('tipo_transaccion')?.value;
      const amount = this.cwForm.get('monto')?.value;
      this.cwForm.get('cargar_retirar_directo')?.setValue(
        this.getDefaultDirectValue(transaction_type, amount)
      );
      this.syncReviewFlagForNonDirectTransactions(transaction_type);
    });

    this.cwForm.get('cargar_retirar_directo')?.valueChanges.subscribe(() => {
      const transactionType = this.cwForm.get('tipo_transaccion')?.value;
      this.syncReviewFlagForNonDirectTransactions(transactionType);
    });
  }

  private shouldAutoReviewForTransaction(
    transactionType: string | number,
  ): boolean {
    const riskyTransactionTypes = [
      TRANSACTION_TYPE_VALUES.LOAD_RISK_VOUCHER,
      TRANSACTION_TYPE_VALUES.WITHDRAW_RISK_VOUCHER,
    ].map(String);

    if (riskyTransactionTypes.includes(String(transactionType))) {
      return false;
    }

    return this.isTransactionTypeAllowed(
      transactionType,
      ALLOWED_TYPES_FOR_CHECK_RECEIPT,
    );
  }

  private syncReviewFlagForNonDirectTransactions(
    transactionType: string | number,
  ): void {
    if (!this.shouldAutoReviewForTransaction(transactionType)) return;

    const isDirectTransaction = !!this.cwForm.get('cargar_retirar_directo')
      ?.value;
    if (!isDirectTransaction) {
      this.cwForm.patchValue(
        {
          estado_revisar_boleta: true,
          estado_boleta_riesgosa: false,
        },
        { emitEvent: false },
      );
    }
  }

  handleTransferInterbankChanges(): void {
    this.cwForm
      .get('transferencia_interbancaria')
      ?.valueChanges.subscribe(() => {
        this.transfer_Type = this.cwForm.get(
          'transferencia_interbancaria',
        )?.value;
        this.alloweEnterprise =
          this.transfer_Type ===
            INTERBANK_TRANSDFER_OPTIONS_VALUES.YES.toString() ||
          this.transfer_Type ===
            INTERBANK_TRANSDFER_OPTIONS_VALUES.OTHERS.toString();
        this.cwForm.get('id_titular')?.setValue(null);
      });

    this.cwForm
      .get('transferencia_interbancaria')
      ?.valueChanges.subscribe(() => {
        if (this.isOcrAutoFilling) return;
        const transferencia_interbancaria = this.cwForm.get(
          'transferencia_interbancaria',
        )?.value;
        if (
          transferencia_interbancaria ===
          INTERBANK_TRANSDFER_OPTIONS_VALUES.YES.toString()
        ) {
          this.checkBankEquality();
        } else if (
          transferencia_interbancaria ===
          INTERBANK_TRANSDFER_OPTIONS_VALUES.OTHERS.toString()
        ) {
          this.checkReceiptEquality();
        }
      });
  }

  handleBankSelectionChanges(): void {
    this.cwForm.get('id_banco')?.valueChanges.subscribe((value) => {
      const transferencia_interbancaria = this.cwForm.get(
        'transferencia_interbancaria',
      )?.value;
      if (
        transferencia_interbancaria ===
          INTERBANK_TRANSDFER_OPTIONS_VALUES.NO.toString() ||
        transferencia_interbancaria ===
          INTERBANK_TRANSDFER_OPTIONS_VALUES.OTHERS.toString()
      ) {
        this.cwForm.get('id_banco_empresa')?.setValue(value);
      }
    });
  }

  enableTitularFieldOnBankSelection(): void {
    this.cwForm.get('id_banco')?.valueChanges.subscribe(() => {
      this.refreshHoldersForSelectedBank();
    });

    this.cwForm.get('id_banco_empresa')?.valueChanges.subscribe(() => {
      this.refreshHoldersForSelectedBank();
    });

    this.cwForm
      .get('transferencia_interbancaria')
      ?.valueChanges.subscribe(() => {
        this.refreshHoldersForSelectedBank();
      });
  }

  updateTitularFieldState(): void {
    const selectedBankId = this.resolveHolderBankId();
    if (selectedBankId) {
      this.cwForm.get('id_titular')?.enable();
    } else {
      this.cwForm.get('id_titular')?.disable();
      this.cwForm.get('id_titular')?.setValue(null);
    }
  }

  private resolveHolderBankId(): number | null {
    const transferencia = this.cwForm.get('transferencia_interbancaria')?.value;
    const bancoCliente = this.cwForm.get('id_banco')?.value;
    const bancoEmpresa = this.cwForm.get('id_banco_empresa')?.value;

    if (
      [
        INTERBANK_TRANSDFER_OPTIONS_VALUES.YES,
        INTERBANK_TRANSDFER_OPTIONS_VALUES.OTHERS,
      ]
        .map(String)
        .includes(String(transferencia))
    ) {
      return bancoEmpresa || null;
    }

    if (
      String(transferencia) === INTERBANK_TRANSDFER_OPTIONS_VALUES.NO.toString()
    ) {
      return bancoCliente || null;
    }

    return bancoCliente || bancoEmpresa || null;
  }

  private refreshHoldersForSelectedBank(): void {
    const bankId = this.resolveHolderBankId();
    const normalizedBankId = bankId ? Number(bankId) : null;

    if (
      normalizedBankId !== null &&
      this.lastResolvedHolderBankId === normalizedBankId &&
      this.allHoldersData.length > 0
    ) {
      this.selectedBankId = normalizedBankId;
      this.cwForm.get('id_titular')?.enable();
      return;
    }

    this.selectedBankId = bankId ?? DEFAULT_VALUE;
    this.allHoldersData = [];
    this.selectedAccountNumber = [];
    this.cwForm.get('id_titular')?.setValue(null);

    if (bankId) {
      this.cwForm.get('id_titular')?.enable();
      this.loadHolders('', true);
      this.lastResolvedHolderBankId = normalizedBankId;
    } else {
      this.cwForm.get('id_titular')?.disable();
      this.lastResolvedHolderBankId = null;
    }
  }

  private ensureBankOptionExists(
    bankId: number,
    bankName: string | null,
    listType: (typeof TYPE_BANK)[keyof typeof TYPE_BANK],
  ): void {
    const list =
      listType === TYPE_BANK.CLIENT
        ? this.allClientBankData
        : this.allEnterpriseBankData;
    const exists = list.some((item) => item.value === bankId);
    if (exists) return;

    const label = bankName?.trim() || `Banco ${bankId}`;
    const nextList = [...list, { label, value: bankId }];
    if (listType === TYPE_BANK.CLIENT) {
      this.allClientBankData = nextList;
    } else {
      this.allEnterpriseBankData = nextList;
    }
  }

  updateFileRequirement(transactionType: string): void {
    this.isFileRequired = [
      TRANSACTION_TYPE_VALUES.LOAD_BALANCE.toString(),
      TRANSACTION_TYPE_VALUES.PAY_TO_DEBIT.toString(),
      TRANSACTION_TYPE_VALUES.CREDIT_DEPOSIT.toString(),
      TRANSACTION_TYPE_VALUES.CREDIT_WITHDRAWAL.toString(),
    ].includes(transactionType);
    this.cwForm.get('foto_comprobante')?.updateValueAndValidity();
  }

  isRequiredImageMissing(): boolean {
    return this.isFileRequired && this.selectedFiles.length === DEFAULT_VALUE;
  }

  getSelectedTransactionLabel(): string {
    const transactionType = this.cwForm.get('tipo_transaccion')?.value;
    const selectedType = TRANSACTION_TYPES.find(
      (item) => item.value === String(transactionType),
    );

    return selectedType?.label || 'este tipo de transacción';
  }

  getRequiredImageMessage(): string {
    return `¡Recuerda que la imagen en ${this.getSelectedTransactionLabel()} es obligatoria!`;
  }

  checkBankEquality(): boolean {
    const transferencia_interbancaria = this.cwForm.get(
      'transferencia_interbancaria',
    )?.value;

    if (
      transferencia_interbancaria ===
      INTERBANK_TRANSDFER_OPTIONS_VALUES.YES.toString()
    ) {
      const id_banco = this.cwForm.get('id_banco')?.value;
      const id_banco_empresa = this.cwForm.get('id_banco_empresa')?.value;

      if (id_banco === id_banco_empresa) {
        this._toastrSvc.error('Los bancos no pueden ser iguales!', '', {
          progressBar: true,
          positionClass: 'custom-toastr-top',
        });
        return true;
      }
    }
    return false;
  }

  checkReceiptEquality(): boolean {
    const transferencia_interbancaria = this.cwForm.get(
      'transferencia_interbancaria',
    )?.value;

    if (
      transferencia_interbancaria ===
      INTERBANK_TRANSDFER_OPTIONS_VALUES.OTHERS.toString()
    ) {
      const comprobante = this.cwForm.get('comprobante')?.value;
      const comprobante_empresa = this.cwForm.get('comprobante_empresa')?.value;

      if (comprobante === comprobante_empresa) {
        this._toastrSvc.error('Los comprobantes no pueden ser iguales!', '', {
          progressBar: true,
          positionClass: 'custom-toastr-top',
        });
        return true;
      }
    }
    return false;
  }

  handleConfirmationCwd() {
    const currentStatus = this.cwForm.get('cargar_retirar_directo')?.value;
    Swal.fire({
      title: '¿Estás seguro?',
      text: currentStatus
        ? '¿Estás seguro de marcar Cargar o Retirar directo?'
        : '¿Estás seguro de desmarcar Cargar o Retirar directo?',
      icon: 'warning',
      iconColor: '#8C98A1',
      showCancelButton: true,
      confirmButtonText: 'Sí',
      confirmButtonColor: '#54BA4A',
      cancelButtonColor: '#5A6268',
      cancelButtonText: 'Cancelar',
    }).then((result) => {
      if (result.isConfirmed) {
        const formControl = this.cwForm.get('cargar_retirar_directo');
        if (formControl) {
          formControl.setValue(currentStatus);
        }

        if (currentStatus) {
          this.cwForm.patchValue({
            estado_revisar_boleta: false,
            estado_boleta_riesgosa: false,
          });
        }
      } else {
        this.cwForm.patchValue({
          cargar_retirar_directo: !currentStatus,
        });
      }
    });
  }

  handleConfirmationRt() {
    const currentStatus = this.cwForm.get('estado_boleta_riesgosa')?.value;
    Swal.fire({
      title: '¿Estás seguro?',
      text: currentStatus
        ? '¿Estás seguro de marcar Boleta Riesgosa?'
        : '¿Estás seguro de desmarcar Boleta Riesgosa?',
      icon: 'warning',
      iconColor: '#8C98A1',
      showCancelButton: true,
      confirmButtonColor: '#54BA4A',
      cancelButtonColor: '#5A6268',
      confirmButtonText: 'Sí',
      cancelButtonText: 'Cancelar',
    }).then((result) => {
      if (result.isConfirmed) {
        const formControl = this.cwForm.get('estado_boleta_riesgosa');
        if (formControl) {
          formControl.setValue(currentStatus);
        }

        if (currentStatus) {
          this.cwForm
            .get('tipo_transaccion')
            ?.setValue(TRANSACTION_TYPE_VALUES.LOAD_RISK_VOUCHER.toString());
          this.loadTypeTransactions();
          this.cwForm.patchValue({
            estado_revisar_boleta: false,
            cargar_retirar_directo: false,
          });
        } else {
          this.cwForm
            .get('tipo_transaccion')
            ?.setValue(TRANSACTION_TYPE_VALUES.LOAD_BALANCE.toString());
          this.loadTypeTransactions();
        }
      } else {
        this.cwForm.patchValue({
          estado_boleta_riesgosa: !currentStatus,
        });
      }
    });
  }

  handleConfirmationCr() {
    const currentStatus = this.cwForm.get('permitirComprobante')?.value;
    Swal.fire({
      title: '¿Estás seguro?',
      text: currentStatus
        ? '¿Estás seguro de marcar Permitir Comporbante Repetido?'
        : '¿Estás seguro de desmarcar Permitir Comporbante Repetido?',
      icon: 'warning',
      iconColor: '#8C98A1',
      showCancelButton: true,
      confirmButtonColor: '#54BA4A',
      cancelButtonColor: '#5A6268',
      confirmButtonText: 'Sí',
      cancelButtonText: 'Cancelar',
    }).then((result) => {
      if (result.isConfirmed) {
        const formControl = this.cwForm.get('permitirComprobante');
        if (formControl) {
          formControl.setValue(currentStatus);
        }
      } else {
        this.cwForm.patchValue({
          permitirComprobante: !currentStatus,
        });
      }
    });
  }

  handleConfirmationTe() {
    const currentStatus = this.cwForm.get('estado_tiempo_espera')?.value;
    Swal.fire({
      title: '¿Estás seguro?',
      text: currentStatus
        ? '¿Estás seguro de marcar Transacción en espera?'
        : '¿Estás seguro de desmarcar Transacción en espera?',
      icon: 'warning',
      iconColor: '#8C98A1',
      showCancelButton: true,
      confirmButtonColor: '#54BA4A',
      cancelButtonColor: '#5A6268',
      confirmButtonText: 'Sí',
      cancelButtonText: 'Cancelar',
    }).then((result) => {
      if (result.isConfirmed) {
        const formControl = this.cwForm.get('estado_tiempo_espera');
        if (formControl) {
          formControl.setValue(currentStatus);
        }
      } else {
        this.cwForm.patchValue({
          estado_tiempo_espera: !currentStatus,
        });
      }
    });
  }

  handleConfirmationRb() {
    const currentStatus = this.cwForm.get('estado_revisar_boleta')?.value;
    Swal.fire({
      title: '¿Estás seguro?',
      text: currentStatus
        ? '¿Estás seguro de marcar Revisar boleta?'
        : '¿Estás seguro de desmarcar Revisar boleta?',
      icon: 'warning',
      iconColor: '#8C98A1',
      showCancelButton: true,
      confirmButtonColor: '#54BA4A',
      cancelButtonColor: '#5A6268',
      confirmButtonText: 'Sí',
      cancelButtonText: 'Cancelar',
    }).then((result) => {
      if (result.isConfirmed) {
        const formControl = this.cwForm.get('estado_revisar_boleta');
        if (formControl) {
          formControl.setValue(currentStatus);
        }

        if (currentStatus) {
          this.cwForm.patchValue({
            estado_boleta_riesgosa: false,
            cargar_retirar_directo: false,
          });
        }
      } else {
        this.cwForm.patchValue({
          estado_revisar_boleta: !currentStatus,
        });
      }
    });
  }

  handleCheckboxChange(checkboxName: string) {
    if (checkboxName === 'cargar_retirar_directo') {
      this.handleConfirmationCwd();
    } else if (checkboxName === 'estado_boleta_riesgosa') {
      this.handleConfirmationRt();
    } else if (checkboxName === 'estado_revisar_boleta') {
      this.handleConfirmationRb();
    } else if (checkboxName === 'permitirComprobante') {
      this.handleConfirmationCr();
    } else if (checkboxName === 'estado_tiempo_espera') {
      this.handleConfirmationTe();
    }
  }

  convertBooleanFieldsToNumbers(data: any): any {
    const convertedData = { ...data };
    const fieldsToConvert = [
      'estado_revisar_boleta',
      'permitirComprobante',
      'cargar_retirar_directo',
      'estado_boleta_riesgosa',
      'estado_tiempo_espera',
      'estado_lista_negra',
    ];

    fieldsToConvert.forEach((field) => {
      if (convertedData[field] === true) {
        convertedData[field] = TRUE_CHECK_VALUE;
      } else {
        convertedData[field] = DEFAULT_VALUE;
      }
    });

    return convertedData;
  }

  onSubmit() {
    this.id_country = this.resolveCountryId();
    if (!this.id_country) {
      this._toastrSvc.error(
        'No se pudo determinar el país de la solicitud. Vuelve a seleccionar el país antes de continuar.',
        '',
        {
          progressBar: true,
          positionClass: 'custom-toastr-top',
        },
      );
      return;
    }

    const transactionType = this.cwForm.get('tipo_transaccion')?.value;
    if (
      this.shouldAutoReviewForTransaction(transactionType) &&
      !this.cwForm.get('cargar_retirar_directo')?.value
    ) {
      this.cwForm.patchValue({
        estado_revisar_boleta: true,
        estado_boleta_riesgosa: false,
      });
    }

    let cwRequestData = this.cwForm.value;
    this.markFormGroupTouched(this.cwForm);
    this.checkFormStatus();
    const transferencia_interbancaria = this.cwForm.get(
      'transferencia_interbancaria',
    )?.value;
    if (
      transferencia_interbancaria === INTERBANK_TRANSDFER_OPTIONS_VALUES.NO ||
      transferencia_interbancaria === INTERBANK_TRANSDFER_OPTIONS_VALUES.OTHERS
    ) {
      const id_banco_value = this.cwForm.get('id_banco')?.value;
      this.cwForm
        .get('id_banco_empresa')
        ?.setValue(id_banco_value, { emitEvent: false });
    }
    if (this.checkBankEquality()) return;
    if (this.checkReceiptEquality()) return;

    if (this.cwForm.valid && !this.showAmountErrorMessage) {
      cwRequestData = this.convertBooleanFieldsToNumbers(cwRequestData);
      cwRequestData[this.isAgent ? 'id_jugador' : 'id_agente'] = this.isAgent
        ? DEFAULT_VALUE
        : this.idusuario;
      this.isLoadingButton = true;
      if (this.isRequiredImageMissing()) {
        if (
          cwRequestData.tipo_transaccion ===
          TRANSACTION_TYPE_VALUES.LOAD_BALANCE.toString()
        ) {
          this._toastrSvc.error(
            'La foto del comprobante es obligatoria para la transacción de Cargar Saldo.',
          );
        } else if (
          cwRequestData.tipo_transaccion ===
          TRANSACTION_TYPE_VALUES.PAY_TO_DEBIT.toString()
        ) {
          this._toastrSvc.error(
            'La foto del comprobante es obligatoria para la transacción de Abonar a Deuda.',
          );
        } else if (
          cwRequestData.tipo_transaccion ===
          TRANSACTION_TYPE_VALUES.CREDIT_DEPOSIT.toString()
        ) {
          this._toastrSvc.error(
            'La foto del comprobante es obligatoria para la transacción de Credito Depósito.',
          );
        } else if (
          cwRequestData.tipo_transaccion ===
          TRANSACTION_TYPE_VALUES.CREDIT_WITHDRAWAL.toString()
        ) {
          this._toastrSvc.error(
            'La foto del comprobante es obligatoria para la transacción de Credito Retiro.',
          );
        }
        this.isLoadingButton = false;
        return;
      }
      this.sendFormData(cwRequestData);
    } else {
      this._toastrSvc.error(
        'Rellena todo el formulario o verifica el monto mínimo!',
        '',
        {
          progressBar: true,
          positionClass: 'custom-toastr-top',
        },
      );
      this.isLoadingButton = false;
    }
  }

  checkProcessingState() {
    const values = this.cwForm.getRawValue();

    const isAiWorking = [values.monto, values.comprobante, values.detalle].some(
      (val) => val === 'Procesando...',
    );

    if (isAiWorking) {
      this.isLoadingButton = true;
    } else {
      this.isLoadingButton = false;
    }
  }

  sendFormData(cwRequestData: any) {
    const countryId = this.resolveCountryId();
    if (!countryId) {
      this.isLoadingButton = false;
      this._toastrSvc.error(
        'No se pudo enviar la solicitud porque el país es inválido.',
        '',
        {
          progressBar: true,
          positionClass: 'custom-toastr-top',
        },
      );
      return;
    }

    const formData = new FormData();
    if (this.profile?.id_rol === ROLES.PAYMENTS_BOSS) {
      formData.append(
        'tipo_transaccion',
        TRANSACTION_TYPE_VALUES.WITHDRAW_RISK_VOUCHER.toString(),
      );
    } else {
      formData.append('tipo_transaccion', cwRequestData.tipo_transaccion);
    }
    formData.append(
      'monto',
      this.normalizeAmountValue(cwRequestData.monto) ?? '',
    );
    if (
      [
        TRANSACTION_TYPE_VALUES.CREDIT_DEPOSIT.toString(),
        TRANSACTION_TYPE_VALUES.CREDIT_WITHDRAWAL.toString(),
        TRANSACTION_TYPE_VALUES.WITHDRAW_RISK_VOUCHER.toString(),
      ].includes(cwRequestData.tipo_transaccion)
    ) {
      formData.append('id_banco', DEFAULT_VALUE.toString());
      formData.append('id_banco_empresa', DEFAULT_VALUE.toString());
      formData.append('id_titular', DEFAULT_VALUE.toString());
    } else {
      formData.append('id_banco', cwRequestData.id_banco);

      if (
        [
          TRANSACTION_TYPE_VALUES.LOAD_BALANCE.toString(),
          TRANSACTION_TYPE_VALUES.LOAD_BONUS_BALANCE.toString(),
          TRANSACTION_TYPE_VALUES.PAY_TO_DEBIT.toString(),
          TRANSACTION_TYPE_VALUES.CREDIT_DEPOSIT.toString(),
        ].includes(cwRequestData.tipo_transaccion)
      ) {
        const isInterbankTransaction = [
          INTERBANK_TRANSDFER_OPTIONS_VALUES.YES,
          INTERBANK_TRANSDFER_OPTIONS_VALUES.OTHERS,
        ].includes(cwRequestData.transferencia_interbancaria);
        if (isInterbankTransaction) {
          formData.append('id_banco_empresa', cwRequestData.id_banco_empresa);
        } else {
          formData.append('id_banco_empresa', cwRequestData.id_banco);
        }
      } else {
        const isWithdrawalOrCommission = [
          TRANSACTION_TYPE_VALUES.WITHDRAW_BALANCE.toString(),
          TRANSACTION_TYPE_VALUES.COLLECT_COMMISSION.toString(),
        ].includes(cwRequestData.tipo_transaccion);

        const isInterbankTransaction = [
          INTERBANK_TRANSDFER_OPTIONS_VALUES.YES,
          INTERBANK_TRANSDFER_OPTIONS_VALUES.OTHERS,
        ].includes(cwRequestData.transferencia_interbancaria);

        if (
          isWithdrawalOrCommission ||
          !cwRequestData.id_banco_empresa ||
          !isInterbankTransaction
        ) {
          formData.append('id_banco_empresa', DEFAULT_VALUE.toString());
        } else {
          formData.append('id_banco_empresa', cwRequestData.id_banco_empresa);
        }
      }

      const shouldExcludeIdTitular =
        this.profile.id_rol === ROLES.AGENT ||
        this.excludeIdTitularConditions.includes(
          cwRequestData.tipo_transaccion,
        );

      if (!shouldExcludeIdTitular) {
        formData.append('id_titular', cwRequestData.id_titular);
      }
    }

    formData.append('comprobante', (cwRequestData.comprobante || '').trim());
    if (
      [
        INTERBANK_TRANSDFER_OPTIONS_VALUES.YES,
        INTERBANK_TRANSDFER_OPTIONS_VALUES.OTHERS,
      ].includes(cwRequestData.transferencia_interbancaria)
    ) {
      formData.append(
        'comprobante_empresa',
        (cwRequestData.comprobante_empresa || '').trim(),
      );
    }
    const accountType = this.isSaving
      ? ACCOUNT_TYPES.SAVINGS
      : ACCOUNT_TYPES.CURRENT;
    formData.append('tipo_cuenta', accountType.toString());
    formData.append(
      'identificacion',
      (cwRequestData.identificacion || '').trim(),
    );
    formData.append('detalle', cwRequestData.detalle);
    formData.append('nombre_titular', cwRequestData.nombre_titular);
    formData.append('nombre_remitente', cwRequestData.nombre_remitente || '');
    formData.append(
      'origen_comprobante_bot',
      cwRequestData.origen_comprobante_bot || '',
    );
    if (this.profile.id_rol === ROLES.AGENT) {
      formData.append('id_agente', this.profile.idusuario);
    } else {
      formData.append('id_agente', cwRequestData.id_agente);
    }
    formData.append('id_jugador', cwRequestData.id_jugador);
    formData.append('id_pais', countryId.toString());
    formData.append(
      'transferencia_interbancaria',
      [
        TRANSACTION_TYPE_VALUES.WITHDRAW_BALANCE.toString(),
        TRANSACTION_TYPE_VALUES.COLLECT_COMMISSION.toString(),
        TRANSACTION_TYPE_VALUES.WITHDRAW_RISK_VOUCHER.toString(),
        TRANSACTION_TYPE_VALUES.CREDIT_WITHDRAWAL.toString(),
        TRANSACTION_TYPE_VALUES.FINANCIAL.toString(),
      ].includes(cwRequestData.tipo_transaccion)
        ? '1'
        : cwRequestData.transferencia_interbancaria,
    );
    formData.append(
      'estado_revisar_boleta',
      cwRequestData.estado_revisar_boleta,
    );
    formData.append('estado_tiempo_espera', cwRequestData.estado_tiempo_espera);
    formData.append(
      'estado_lista_negra',
      this.blackList ? TRUE_CHECK_VALUE.toString() : DEFAULT_VALUE.toString(),
    );
    formData.append(
      'permitir_comprobante_repetido',
      cwRequestData.permitirComprobante,
    );
    formData.append(
      'cargar_retirar_directo',
      [
        TRANSACTION_TYPE_VALUES.CREDIT_WITHDRAWAL.toString(),
        TRANSACTION_TYPE_VALUES.CREDIT_DEPOSIT.toString(),
      ].includes(cwRequestData.tipo_transaccion) || cwRequestData.cargar_retirar_directo
        ? '1'
        : '0',
    );
    formData.append(
      'estado_boleta_riesgosa',
      this.profile?.id_rol === ROLES.PAYMENTS_BOSS
        ? TRUE_CHECK_VALUE.toString()
        : cwRequestData.estado_boleta_riesgosa,
    );

    formData.append(
      'numero_cuenta',
      (cwRequestData.numero_cuenta || '').trim(),
    );

    for (let file of this.selectedFiles) {
      formData.append('foto_comprobante', file.file, file.file.name);
    }

    this._toastrSvc.info('Procesando...', '', {
      timeOut: 500,
    });

    this._cwService.createRequest(formData).subscribe(
      (response) => {
        this.isLoadingButton = false;
        this._toastrSvc.success('La solicitud se ha creado exitosamente.', '', {
          progressBar: true,
          positionClass: 'custom-toastr-top',
        });
        this.closeModal();
      },
      (err) => {
        this.isLoadingButton = false;
      },
    );
  }

  validatorsAmountImg() {
    const userEnteredAmount = this.cwForm.get('monto')?.value;
    const imageAmount = this.amountVoucher;
    const hasUserAmount =
      userEnteredAmount !== null &&
      userEnteredAmount !== undefined &&
      userEnteredAmount !== '';
    const hasImageAmount =
      imageAmount !== null && imageAmount !== undefined && imageAmount !== '';

    if (!hasUserAmount || !hasImageAmount || this.isManual) {
      this.amountError = false;
    } else if (userEnteredAmount !== imageAmount) {
      this.amountError = true;
    } else {
      this.amountError = false;
    }
    this.checkMinimumAmount();
  }

  validatorsReciptImg() {
    const userEnteredReceipt = this.cwForm.get('comprobante')?.value;
    const imageReceipt = this.receipVoucher;
    if (userEnteredReceipt !== imageReceipt && !this.isManual) {
      this.reciptError = true;
    } else {
      this.reciptError = false;
    }
  }

  updateTransactionValidators(
    transactionType: string,
    tipo_usuario: string,
  ): void {
    const validatorsRequired = Validators.required;
    const shouldExcludeIdTitular =
      this.excludeIdTitularConditions.includes(transactionType) ||
      this.profile.id_rol === ROLES.AGENT;

    this.clearValidators([
      'monto',
      'id_banco',
      'id_banco_empresa',
      'id_agente',
      'id_jugador',
      'id_titular',
      'comprobante',
      'comprobante_empresa',
      'nombre_titular',
      'identificacion',
      'numero_cuenta',
      'detalle',
    ]);
    if (
      this.isTransactionTypeAllowed(
        transactionType,
        ALLOWED_TYPES_FOR_MONTO_BANK_RECEIPT,
      )
    ) {
      this.setValidators(
        ['monto', 'id_banco', 'comprobante'],
        validatorsRequired,
      );
      if (tipo_usuario !== USER_TYPES.AGENT_LEVEL_ONE) {
        const fields = ['id_agente', 'id_jugador'];
        if (!shouldExcludeIdTitular) {
          fields.push('id_titular');
        }
        this.setValidators(fields, validatorsRequired);
      }
    } else if (
      this.isTransactionTypeAllowed(
        transactionType,
        ALLOWED_TYPES_FOR_MONTO_BANK_ID_ACCOUNT,
      )
    ) {
      this.setValidators(['monto'], validatorsRequired);
      if (tipo_usuario !== USER_TYPES.AGENT_LEVEL_ONE) {
        this.setValidators(['id_agente', 'id_jugador'], validatorsRequired);
      }
    } else if (
      this.isTransactionTypeAllowed(transactionType, ALLOWED_TYPES_FOR_MONTO)
    ) {
      this.setValidators(['monto'], validatorsRequired);
      if (tipo_usuario !== USER_TYPES.AGENT_LEVEL_ONE) {
        this.setValidators(['id_agente', 'id_jugador'], validatorsRequired);
      }
    }

    if (this.isDetailRequired(transactionType)) {
      this.setValidators(['detalle'], validatorsRequired);
    }

    this.cwForm.updateValueAndValidity();
  }

  isDetailRequired(transactionType: string | number | null): boolean {
    return [
      TRANSACTION_TYPE_VALUES.PAY_TO_DEBIT,
      TRANSACTION_TYPE_VALUES.CREDIT_DEPOSIT,
      TRANSACTION_TYPE_VALUES.CREDIT_WITHDRAWAL,
    ]
      .map(String)
      .includes(String(transactionType));
  }

  clearValidators(fields: string[]): void {
    fields.forEach((field) => {
      this.cwForm.get(field)?.clearValidators();
      this.cwForm.get(field)?.updateValueAndValidity();
    });
  }

  setValidators(fields: string[], validator: ValidatorFn): void {
    fields.forEach((field) => {
      this.cwForm.get(field)?.setValidators(validator);
      this.cwForm.get(field)?.updateValueAndValidity();
    });
  }

  checkFormStatus() {
    const invalidFields = [];
    const formControls = this.cwForm.controls;

    for (const name in formControls) {
      if (formControls[name].invalid) {
        invalidFields.push(name);
      }
    }
  }

  markFormGroupTouched(formGroup: FormGroup) {
    Object.values(formGroup.controls).forEach((control) => {
      if (control instanceof FormGroup) {
        this.markFormGroupTouched(control);
      } else {
        control.markAsTouched();
      }
    });
  }

  checkMinimumAmount() {
    const montoInputValue = this.cwForm.get('monto')?.value;
    const id_country = this.id_country;
    const selectedTransactionType = this.cwForm.get('tipo_transaccion')?.value;
    let minimumAmount: number;

    if (
      selectedTransactionType ===
      TRANSACTION_TYPE_VALUES.PAY_TO_DEBIT.toString()
    ) {
      this.showAmountErrorMessage = false;
      this.amountErrorMessage = '';
      return;
    }

    if (
      selectedTransactionType ===
        TRANSACTION_TYPE_VALUES.CREDIT_DEPOSIT.toString() ||
      selectedTransactionType ===
        TRANSACTION_TYPE_VALUES.CREDIT_WITHDRAWAL.toString()
    ) {
      this.showAmountErrorMessage = false;
      this.amountErrorMessage = '';
      return;
    }

    if (id_country === CURRENCY_VALUES.ECU) {
      minimumAmount = minimum_amount_ec;
    } else if (id_country === CURRENCY_VALUES.PER) {
      minimumAmount = minimum_amount_pe;
    } else {
      minimumAmount = DEFAULT_VALUE;
    }

    if (parseFloat(montoInputValue) < minimumAmount) {
      this.showAmountErrorMessage = true;
      this.amountErrorMessage = `El monto mínimo es $${minimumAmount}`;
    } else {
      this.showAmountErrorMessage = false;
      this.amountErrorMessage = '';
    }
  }

  private loadWithdrawalDirectLimit(): void {
    this._configService.getByKey(WITHDRAWAL_DIRECT_LIMIT_KEY).subscribe({
      next: (res) => {
        const parsed = parseFloat(res?.data?.valor);
        if (!isNaN(parsed)) {
          this.withdrawalDirectLimit = parsed;
        }
      },
    });
  }

  private loadActiveOcrProvider(): void {
    this.ocrService.getActiveProvider().subscribe({
      next: (res) => {
        if (res?.data?.provider === 'ollama') {
          this.activeOcrProvider = 'ollama';
        }
      },
    });
  }

  private getDefaultDirectValue(transactionType: string | number, amount: string | number | null): boolean {
    const isWithdrawal = WITHDRAWAL_TYPES_FOR_DIRECT_DEFAULT
      .map(String)
      .includes(String(transactionType));
    if (!isWithdrawal) return false;
    const parsedAmount = parseFloat(String(amount));
    return isNaN(parsedAmount) || parsedAmount < this.withdrawalDirectLimit;
  }

  isWithdrawalBelowDirectLimit(): boolean {
    const transactionType = this.cwForm.get('tipo_transaccion')?.value;
    const amount = this.cwForm.get('monto')?.value;
    const parsedAmount = parseFloat(amount);
    if (isNaN(parsedAmount) || parsedAmount <= 0) return false;
    return this.getDefaultDirectValue(transactionType, amount);
  }

  isBankSelected(): boolean {
    return !this.cwForm.get('id_banco')?.value;
  }

  isTransactionTypeAllowed(
    transactionType: string | number,
    allowedTypes: (string | number)[],
  ): boolean {
    return allowedTypes.map(String).includes(String(transactionType));
  }

  get isInterbankTransaction(): boolean {
    const validInterbankOptions = [
      INTERBANK_TRANSDFER_OPTIONS_VALUES.YES,
      INTERBANK_TRANSDFER_OPTIONS_VALUES.OTHERS,
      INTERBANK_TRANSDFER_OPTIONS_VALUES.NO,
    ];
    return validInterbankOptions.includes(
      this.cwForm.get('transferencia_interbancaria')?.value,
    );
  }

  onChangeTypeTransaction(event: any) {
    this.clearAttachedImageState();
    const estadoBoletaRiesgosa = this.cwForm.get('estado_boleta_riesgosa')?.value;
    this.cwForm.reset();
    this.cwForm.patchValue({
      tipo_transaccion: event.value,
      transferencia_interbancaria: INTERBANK_TRANSDFER_OPTIONS_VALUES.NO,
      estado_boleta_riesgosa: estadoBoletaRiesgosa,
    });
  }

  onInputChange(event: any) {
    const rawValue = event.target.value || '';
    let normalizedValue = rawValue.replace(/\s+/g, '').replace(/,/g, '.');

    if (normalizedValue.startsWith('.')) {
      normalizedValue = `0${normalizedValue}`;
    }

    if (normalizedValue !== rawValue) {
      event.target.value = normalizedValue;
      this.cwForm.get('monto')?.setValue(normalizedValue, { emitEvent: false });
    }
  }

  fillFromPaste(): void {
    const rawPasteText = this.pasteTextArea.trim();
    if (!rawPasteText) {
      this._toastrSvc.error(CW_PASTE_TEXT.EMPTY_INPUT_ERROR);
      return;
    }

    const lines = rawPasteText.split('\n');
    const validLinesCount = this.countValidPasteLines(lines);

    if (validLinesCount < CW_PASTE_RULES.MIN_VALID_LINES) {
      this.showInvalidPasteFormatToast();
      return;
    }

    this.isFillingFromPaste = true;
    const parsed = this.parsePasteData(lines);
    const parsedAmount = this.parseAmount(parsed[CW_PASTE_FIELDS.AMOUNT]);
    const fullName = [
      parsed[CW_PASTE_FIELDS.FIRST_NAME],
      parsed[CW_PASTE_FIELDS.LAST_NAME],
    ]
      .filter(Boolean)
      .join(' ');

    this.cwForm.patchValue({
      monto: parsedAmount ?? this.cwForm.get('monto')?.value,
      nombre_titular: fullName || this.cwForm.get('nombre_titular')?.value,
      identificacion:
        parsed[CW_PASTE_FIELDS.IDENTIFICATION] ||
        this.cwForm.get('identificacion')?.value,
      numero_cuenta:
        parsed[CW_PASTE_FIELDS.ACCOUNT] ||
        this.cwForm.get('numero_cuenta')?.value,
    });

    this.amountError = false;
    this.reciptError = false;
    this.amountVoucher = parsedAmount;

    if (parsed[CW_PASTE_FIELDS.BANK]) {
      const bankOption = this._bankMatcher.findBestMatch(
        parsed[CW_PASTE_FIELDS.BANK] ?? '',
        this.allClientBankData,
      );
      if (bankOption) {
        this.cwForm.get('id_banco')?.setValue(bankOption.value);
        this.onBankSelected({ value: bankOption.value });
      }
    }

    const agentName = parsed[CW_PASTE_FIELDS.AGENT];
    if (agentName && agentName.length > 0) {
      this._userMainService
        .getAllReferredAndAgents(
          CW_PASTE_RULES.AGENT_SEARCH_PAGE,
          this.pageSize,
          agentName,
          this.id_country,
          userOnlyActive,
        )
        .subscribe({
          next: (response) => {
            const agents = response.data.map((item: any) => ({
              label: item.usuario,
              value: item.idusuario,
              backofficeAgent: item.id_remoto,
              whiteList: item.agente_white_list?.lista_negra,
            }));

            const searchTerm = this.normalizeAgentName(agentName);
            const agentOption = agents.find((agent: any) => {
              const label = this.normalizeAgentName(agent.label);
              return label === searchTerm;
            });

            if (agentOption) {
              if (
                !this.allAgentsData.some((a) => a.value === agentOption.value)
              ) {
                this.allAgentsData = [...this.allAgentsData, ...agents];
                this.optionsAgents$ = of(this.allAgentsData);
              }
              this.cwForm.get('id_agente')?.setValue(agentOption.value);
              this.onSelectionChange();
            } else {
              this._toastrSvc.warning(
                `${CW_PASTE_TEXT.AGENT_NOT_FOUND_PREFIX}${agentName}`,
                '',
                {
                  progressBar: true,
                  positionClass: CW_PASTE_TOAST.POSITION_CLASS,
                },
              );
            }

            this.finishPasteFlow(true);
          },
          error: () => {
            this.finishPasteFlow(false);
            this._toastrSvc.error(CW_PASTE_TEXT.AGENT_SEARCH_ERROR, '', {
              progressBar: true,
              positionClass: CW_PASTE_TOAST.POSITION_CLASS,
            });
          },
        });
    } else {
      this.finishPasteFlow(true);
    }
  }

  private showInvalidPasteFormatToast(): void {
    this._toastrSvc.error(CW_PASTE_TEXT.INVALID_FORMAT_ERROR, '', {
      progressBar: true,
      enableHtml: true,
      timeOut: CW_PASTE_TOAST.INVALID_FORMAT_TIMEOUT_MS,
      positionClass: CW_PASTE_TOAST.POSITION_CLASS,
    });
  }

  private normalizeAgentName(value: string): string {
    return value
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/\s+/g, '')
      .toLowerCase()
      .trim();
  }

  private countValidPasteLines(lines: string[]): number {
    return lines.filter((line) => {
      const [key, value] = this.extractLineKeyValue(line);
      return Boolean(key && value);
    }).length;
  }

  private parsePasteData(
    lines: string[],
  ): Partial<Record<CwPasteField, string>> {
    const parsed: Partial<Record<CwPasteField, string>> = {};

    for (const line of lines) {
      const [rawKey, value] = this.extractLineKeyValue(line);
      if (!rawKey || !value) {
        continue;
      }

      const key = rawKey.toLowerCase();

      if (
        this.containsAnyKeyword(
          key,
          CW_PASTE_FIELD_KEYWORDS[CW_PASTE_FIELDS.AGENT],
        )
      ) {
        parsed[CW_PASTE_FIELDS.AGENT] = value;
      }
      if (
        this.containsAnyKeyword(
          key,
          CW_PASTE_FIELD_KEYWORDS[CW_PASTE_FIELDS.AMOUNT],
        )
      ) {
        parsed[CW_PASTE_FIELDS.AMOUNT] = value;
      }
      if (
        this.containsAnyKeyword(
          key,
          CW_PASTE_FIELD_KEYWORDS[CW_PASTE_FIELDS.FIRST_NAME],
        ) &&
        !this.containsAnyKeyword(
          key,
          CW_PASTE_FIELD_KEYWORDS[CW_PASTE_FIELDS.LAST_NAME],
        )
      ) {
        parsed[CW_PASTE_FIELDS.FIRST_NAME] = value;
      }
      if (
        this.containsAnyKeyword(
          key,
          CW_PASTE_FIELD_KEYWORDS[CW_PASTE_FIELDS.LAST_NAME],
        )
      ) {
        parsed[CW_PASTE_FIELDS.LAST_NAME] = value;
      }
      if (
        this.containsAnyKeyword(
          key,
          CW_PASTE_FIELD_KEYWORDS[CW_PASTE_FIELDS.IDENTIFICATION],
        )
      ) {
        parsed[CW_PASTE_FIELDS.IDENTIFICATION] = value;
      }
      if (
        this.containsAnyKeyword(
          key,
          CW_PASTE_FIELD_KEYWORDS[CW_PASTE_FIELDS.BANK],
        )
      ) {
        parsed[CW_PASTE_FIELDS.BANK] = value;
      }
      if (
        this.containsAnyKeyword(
          key,
          CW_PASTE_FIELD_KEYWORDS[CW_PASTE_FIELDS.ACCOUNT],
        )
      ) {
        parsed[CW_PASTE_FIELDS.ACCOUNT] = value;
      }
    }

    return parsed;
  }

  private extractLineKeyValue(line: string): [string, string] {
    const separatorIndex = line.indexOf(CW_PASTE_RULES.FIELD_SEPARATOR);
    if (separatorIndex === -1) {
      return ['', ''];
    }

    const key = line.substring(0, separatorIndex).trim();
    const value = line.substring(separatorIndex + 1).trim();
    return [key, value];
  }

  private containsAnyKeyword(text: string, keywords: string[]): boolean {
    return keywords.some((keyword) => text.includes(keyword));
  }

  /**
   * MySQL only accepts a dot as decimal separator, so any comma coming from
   * OCR, paste or a mobile keyboard is rewritten before it reaches the API.
   */
  private normalizeAmountValue(rawAmount: unknown): string | null {
    if (rawAmount === null || rawAmount === undefined) {
      return null;
    }

    const normalized = String(rawAmount).trim().replace(/,/g, '.');
    return normalized || null;
  }

  private parseAmount(rawAmount?: string): number | null {
    if (!rawAmount) {
      return null;
    }

    const normalized = rawAmount.replace(/[^0-9.,]/g, '').replace(',', '.');
    const amount = parseFloat(normalized);
    return Number.isNaN(amount) ? null : amount;
  }

  private finishPasteFlow(success: boolean): void {
    this.isFillingFromPaste = false;

    if (success) {
      this._toastrSvc.success(CW_PASTE_TEXT.SUCCESS, '', {
        progressBar: true,
        positionClass: CW_PASTE_TOAST.POSITION_CLASS,
      });
    }

    this.pasteTextArea = '';
  }
}
